import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import {
    searchSubProcess,
    updateWorkSubProcess,
    clear_work_subprocess,
    UPDATE_WORK_SUBPROCESS,
} from "../../../redux/work_subprocess";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";
import {Switch, Space} from "antd";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import { CREATE_WORK_ACTIVITY, createWorkActivity, clear_work_activity } from "../../../redux/work_activities";
import { getAllWorkSheets } from "../../../redux/work_sheets";
import {
    clear_work_subprocess_risk,
    CREATE_WORK_SUBPROCESS_RISK,
    createWorkSubprocessRisk,
    DELETE_WORK_SUBPROCESS_RISK,
    updateWorkSubprocessRisk,
    deleteWorkSubprocessRisk,
    UPDATE_WORK_SUBPROCESS_RISK,
} from "../../../redux/work_subprocess_risks";
import TextArea from "../../../components/text-area";

const UpdateWorkSubProcess = () => {
    let history = useHistory();
    const {id_work_sheet, id_work_process, id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _create_work_activity = useSelector((state) => state.work_activities_module._create_work_activity);
    const _get_all_critical_levels = useSelector((state) => state.critical_levels_module._get_all_critical_levels);
    const _create_work_subprocess_risk = useSelector((state) => state.work_subprocess_risks_module._create_work_subprocess_risk);
    const _update_work_subprocess_risk = useSelector((state) => state.work_subprocess_risks_module._update_work_subprocess_risk);
    const _delete_work_subprocess_risk = useSelector((state) => state.work_subprocess_risks_module._delete_work_subprocess_risk);

    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalRisk, setModalRisk] = useState(false);
    const [activity, setActivity] = useState('');
    const [risk, setRisk] = useState('');
    const [id_risk, setIdRisk] = useState(0);
    const [id_nivel_critico, setIdNivelCritico] = useState(0);
    const [critical_points, setCritcalPoints] = useState(0);
    const [criticalLevels, setCriticalLevels] = useState([]);
    const [description, setDescription] = useState('');

    const _update_work_subprocess = useSelector((state) => state.work_subprocess_module._update_work_subprocess);

    const [form, setForm] = useState({
        nombre: "",
        id_proceso_trabajo: 0,
        proceso_trabajo: "",
        activo: true,
        actividades: [],
        riesgos: [],
    });

    useEffect(() => {
        if (_get_all_critical_levels.data.datos) {
            let value = _get_all_critical_levels.data.datos.filter(x => x.activo === true);
            setCriticalLevels(value);
        }
    }, [_get_all_critical_levels]);

    async function get_subprocess() {
        // eslint-disable-next-line
        let params = "?id=" + id;
        const response = await searchSubProcess(token, params);
        try {
            if (response && response.data && response.data.cantidad > 0) {
                let data = response.data.datos[0];
                setForm(data);
            }
        } catch (e) {
            console.log('Error')
        }
    }

    useEffect(() => {
        get_subprocess();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        if (_update_work_subprocess.status === 200) {
            dispatch(clear_work_subprocess(UPDATE_WORK_SUBPROCESS));
            history.push(`/proceso-trabajo/detalle/${id_work_sheet}/${id_work_process}`);
            dispatch(getAllWorkSheets(token));
            setIsLoading(false);
        } else if (_update_work_subprocess.status !== 0) {
            dispatch(clear_work_subprocess(UPDATE_WORK_SUBPROCESS));
            toast.error(_update_work_subprocess.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_work_subprocess, dispatch, history, token, id_work_sheet, id_work_process]);

    
    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateWorkSubProcess(token, id, form));
    };

    useEffect(() => {
        if (_create_work_activity.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_activity(CREATE_WORK_ACTIVITY));
            dispatch(getAllWorkSheets(token));
            get_subprocess();
            setIsLoading(false);
            setModal(false);
        } else if (_create_work_activity.status !== 0) {
            dispatch(clear_work_activity(CREATE_WORK_ACTIVITY));
            toast.error(_create_work_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_work_activity, dispatch, history, token]);

    const handleSubmitActivity = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (activity === '') {
            toast.error("Debe ingresar la actividad", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id_nivel_critico === 0) {
            toast.error("Debe seleccionar un nivel crítico", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (critical_points < 0) {
            toast.error("Debe ingresar los puntos críticos", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createWorkActivity(token, {nombre: activity, id_subproceso: id, id_nivel_critico: id_nivel_critico, puntos_critico: critical_points, descripcion: description}));
    };

    useEffect(() => {
        if (_create_work_subprocess_risk.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_subprocess_risk(CREATE_WORK_SUBPROCESS_RISK));
            dispatch(getAllWorkSheets(token));
            get_subprocess();
            setIsLoading(false);
            setModalRisk(false);
        } else if (_create_work_subprocess_risk.status !== 0) {
            dispatch(clear_work_subprocess_risk(CREATE_WORK_SUBPROCESS_RISK));
            toast.error(_create_work_subprocess_risk.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_work_subprocess_risk, dispatch, history, token]);

    useEffect(() => {
        if (_update_work_subprocess_risk.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_work_subprocess_risk(UPDATE_WORK_SUBPROCESS_RISK));
            dispatch(getAllWorkSheets(token));
            get_subprocess();
            setIsLoading(false);
            setModalRisk(false);
        } else if (_update_work_subprocess_risk.status !== 0) {
            dispatch(clear_work_subprocess_risk(UPDATE_WORK_SUBPROCESS_RISK));
            toast.error(_update_work_subprocess_risk.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_work_subprocess_risk, dispatch, history, token]);

    const handleSubmitRisk = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (risk === '') {
            toast.error("Debe ingresar el riesgo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id_risk === 0) {
            dispatch(createWorkSubprocessRisk(token, {nombre: risk, id_subproceso: id}));
        } else {
            dispatch(updateWorkSubprocessRisk(token, id_risk, {nombre: risk}));
        }
    };

    useEffect(() => {
        if (_delete_work_subprocess_risk.status === 200) {
            dispatch(clear_work_subprocess_risk(DELETE_WORK_SUBPROCESS_RISK));
            dispatch(getAllWorkSheets(token));
            get_subprocess();
            setIsLoading(false);
        } else if (_delete_work_subprocess_risk.status !== 0) {
            dispatch(clear_work_subprocess_risk(DELETE_WORK_SUBPROCESS_RISK));
            toast.error(_delete_work_subprocess_risk.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_delete_work_subprocess_risk, dispatch, history, token]);

    function delete_risk(id_risk) {
        setIsLoading(true);
        dispatch(deleteWorkSubprocessRisk(token, id_risk));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hojas de trabajos"
                            items={[
                                {label: "Detalles", link: "/hojas-trabajos"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Subproceso</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Proceso de trabajo</label>
                                                <SelectInput
                                                    label="proceso_trabajo"
                                                    name="id_proceso_trabajo"
                                                    value={form.id_proceso_trabajo}
                                                    select={form.proceso_trabajo}
                                                    disabled={true}
                                                    options={[{
                                                        name: form.proceso_trabajo,
                                                        id: form.id_proceso_trabajo,
                                                    }]}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <Space size={14} direction='horizontal'>
                                                    <strong>Activo</strong>
                                                    <Switch
                                                        checked={form.activo}
                                                        checkedChildren="SI"
                                                        unCheckedChildren="NO"
                                                        onChange={handleCheckedChange}
                                                    />
                                                </Space>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Actividades</p>
                                            <p className="text-body">Sección para asignar las actividades que conforman el subproceso seleccionado</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1" onChange={() => {
                                                setModal(true);
                                                setActivity('');
                                                setIdNivelCritico(0);
                                                setCritcalPoints(0);
                                                setDescription('');
                                                document.getElementById('id_nivel_critico').selectedIndex = 0;
                                            }}/>
                                        </div>
                                        {form.actividades.length > 0 && (
                                            form.actividades.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '90%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                                <strong className="texto_16">Nivel crítico: {item.nivel_critico}</strong><br/>
                                                                <span className="texto_14">{item.activo ? 'Activo' : 'Inactivo'}</span>
                                                            </div>
                                                        </div>
                                                        <div className="text-right mt-2" style={{width: "10%"}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/edit.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {history.push(`/actividad-trabajo/detalle/${id_work_sheet}/${id_work_process}/${id}/${item.id}`);}}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                        <div className="col-12 mb-2">
                                            <p className="text-title">Riesgos</p>
                                            <p className="text-body">Sección para asignar los riesgos que se relacionarán con las actividades del subproceso</p>
                                            <Button type="button" text="Agregar" theme="calendar" classes="mb-1" onChange={() => {
                                                setModalRisk(true);
                                                setRisk('');
                                                setIdRisk(0);
                                            }}/>
                                        </div>
                                        {form.riesgos.length > 0 && (
                                            form.riesgos.map((item) => (
                                                <div className="col-md-6 col-12 mb-1">
                                                    <div className="d-flex p-1 border-card">
                                                        <div className="d-flex" style={{width: '80%'}}>
                                                            <div className="ml-1">
                                                                <span className="texto_20">{item.nombre}</span><br/>
                                                            </div>
                                                        </div>
                                                        <div className="text-right" style={{width: '20%'}}>
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/edit.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    setIdRisk(parseInt(item.id));
                                                                    setRisk(item.nombre);
                                                                    setModalRisk(true);
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                            <img
                                                                src={window.location.origin + "/base/app-assets/images/icon/delete.png"}
                                                                alt="img"
                                                                height="20"
                                                                width="20"
                                                                onClick={() => {
                                                                    delete_risk(item.id)
                                                                }}
                                                                style={{cursor: "pointer"}}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    <div className="card-footer button_responsive">
                                        <Button text="Cancelar" onChange={() => {
                                            history.push(`/proceso-trabajo/detalle/${id_work_sheet}/${id_work_process}`);
                                        }} className="btn btn-outline-dark magin_button button_responsible"/>

                                        <Button type="submit" text="Guardar" theme="calendar" classes="button_responsible"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitActivity}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar actividad</h5>
                        <div className="form-group">
                            <Input
                                name="activity"
                                label="Actividad"
                                value={activity}
                                onChange={(e) => {setActivity(e.target.value)}}
                            />
                        </div>
                        <div className="form-group">
                            <label>Nivel crítico</label>
                            <SelectInput
                                id="id_nivel_critico"
                                label="nivel_critico"
                                name="id_nivel_critico"
                                value={id_nivel_critico}
                                onChange={(e) => setIdNivelCritico(parseInt(e.target.value))}
                                options={criticalLevels ? criticalLevels.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                name="puntos_criticos"
                                label="Puntos críticos"
                                value={critical_points}
                                type="number"
                                onChange={(e) => {setCritcalPoints(e.target.value)}}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                name="descripcion"
                                label="Descripción"
                                placeholder=""
                                onChange={(e) => {setDescription(e.target.value)}}
                                rows={4}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modalRisk}>
                <form onSubmit={handleSubmitRisk}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id_risk === 0 ? 'Agregar' : 'Editar'} riesgos</h5>
                        <div className="form-group">
                            <Input
                                name="risk"
                                label="Riesgo"
                                value={risk}
                                onChange={(e) => {setRisk(e.target.value)}}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {
                            setModalRisk(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default UpdateWorkSubProcess;
